<template>
    <v-container class='containerPage'>
        <div class="page">
            <header class="header" v-bind:style="{ 'max-height': headerHeight || '6%' }">
                <slot name="header"></slot>
            </header>
            <body class="body" v-bind:style="{ 'max-height': bodyHeight || '60%', 'height': bodyHeight || 'max-content'}">
                <slot name="body"></slot>
            </body>
            <body class="footer" v-bind:style="{ 'max-height': footerHeight }">
                <slot name="footer"></slot>
            </body>
        </div>
    </v-container>
</template>

<script>

export default {
    name: 'ContainerPage',
    props: ['headerHeight','bodyHeight','footerHeight'],
    data() {
        return {
            // bodyHeight: '60%'
        }
    },
    computed: {
    },
    methods: {
    }

}
</script>
<style scoped>
.containerPage{
    max-width: none !important;
    width: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
    padding: 2% 0px 4% 70px;
    text-align: left;
    position: fixed;
    height: calc(100% - 40px);
}
.page{
    height: 100%;
}
.containerPage::-webkit-scrollbar {
    width: 8px;
}

.containerPage::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.containerPage::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.header{
    height: max-content;
    /* min-height: 125px; */
}
.body{
    overflow-y: auto;
    overflow-x: hidden;
    /* height: max-content; */
    width: 100%;
}
.body::-webkit-scrollbar {
    width: 8px;
}

.body::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.body::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}

@media only screen and (max-width: 360px){
    .containerPage{
        padding-left:10px;
    }
    .header{
        display: grid;
        justify-content: center;
        padding-right: 0;
        max-height: 16% !important;
        min-height: 125px;
    }
    /* .page{
        width: 98%;
    } */
    .body{
        max-height: 80% !important;
    }
}
@media only screen and (min-width: 361px) and (max-width: 680px){
    .containerPage{
        padding-left:10px;
    }
    /* .page{
        width: 98%;
    } */
    .header{
        display: grid;
        justify-content: center;
        padding-right: 0;
        max-height: 33% !important;
        min-height: 125px;
    }
    .body{
        max-height: 76% !important;
    }
}
@media only screen and (min-width: 681px) and (max-width: 980px){
    .header{
        min-height: 100px;
    }
}
</style>